module.exports = __webpack_public_path__ + "static/squares-pictures-1-d20190fe8a698478065aad27a25a520e.png";